module.exports = __webpack_public_path__ + "static/branding-87f16aee758c001b81161bd22fb0f22f.png";